var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"min-h-full bg-main-bg login-layout pt-20"},[_c('div',{staticClass:"max-w-lg md:w-10/12 mx-auto"},[_c('ContentColumn',[_c('div',{attrs:{"id":"pre-login-form"}}),_vm._t("default"),_c('div',{attrs:{"id":"post-login-form"}})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }